import { createV3Queries } from "@query/utils/createV3Queries";
import { cashbackApi } from "@api";

export const queriesCashback = createV3Queries("cashbackApi", cashbackApi);
